import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ProductionTerminalService } from '@shared/services/production-terminal.service';
import { LocalStorageService } from '@shared/services/storage.service';

@Component({
	selector: 'app-slide-panel',
	templateUrl: './slide-panel.component.html',
	styleUrls: ['./slide-panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SlidePanelComponent implements OnInit {
	@Input() stateStorageName: string;

	@ViewChild('box') boxRef!: ElementRef;
	@ViewChild('target') targetRef!: ElementRef;

	isOpen = true;
	isSliding = false;
	hideContent: boolean;
	boxWidth: number;

	constructor(
		private localStorageService: LocalStorageService,
		private terminalService: ProductionTerminalService,
	) {}

	ngOnInit(): void {
		if (this.stateStorageName) {
			this.isOpen = this.localStorageService.get(`${this.stateStorageName}#SlidePanel#IsOpen`) === 'true';
			this.isSliding = this.localStorageService.get(`${this.stateStorageName}#SlidePanel#IsSliding`) === 'true';
		}
		this.hideContent = !this.isOpen;
	}

	ngAfterViewInit(): void {
		// The width of the content can't be measured when hidden so first show for measuring and then hide.
		setTimeout(() => {
			this.boxWidth = this.boxRef.nativeElement.offsetWidth;
			if (this.hideContent) {
				this.targetRef.nativeElement.style.left = `-${this.boxWidth}px`;
			}
		}, 1000);
	}

	togglePanel(): void {
		this.boxWidth = this.boxRef.nativeElement.offsetWidth;
		if (this.hideContent) {
			this.targetRef.nativeElement.style.left = `-${this.boxWidth}px`;
			this.hideContent = false;
		}
		if (this.isOpen) {
			this.isOpen = false;
			this.targetRef.nativeElement.style.left = `-${this.boxWidth}px`;
			if (this.stateStorageName) {
				this.localStorageService.set(`${this.stateStorageName}#SlidePanel#IsOpen`, 'false');
			}
		} else {
			this.isOpen = true;
			this.targetRef.nativeElement.style.left = '0';
			if (this.stateStorageName) {
				this.localStorageService.set(`${this.stateStorageName}#SlidePanel#IsOpen`, 'true');
			}
		}
	}

	toggleSliding(): void {
		this.isSliding = !this.isSliding;
		if (this.stateStorageName) {
			this.localStorageService.set(`${this.stateStorageName}#SlidePanel#IsSliding`, this.isSliding.toString());
		}
	}
}
